export * from './context';
export * from './htmlText';
export * from './interpolate';
export * from './linkText';
export * from './locale';
export * from './provider';
export * from './text';
export * from './time';
export * from './useTranslations';
export * from './withTranslations';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ilenia/dist/index.js
// module id = 5
// module chunks = 0